export const de = {
  // ISO weekday order, Monday first — the same order `users.work_weekdays` stores.
  weekdaysShort: {
    mon: "Mo",
    tue: "Di",
    wed: "Mi",
    thu: "Do",
    fri: "Fr",
    sat: "Sa",
    sun: "So",
  },
  common: {
    signIn: "Anmelden",
    signOut: "Abmelden",
    loading: "Lädt…",
    save: "Speichern",
    saving: "Speichern…",
    cancel: "Abbrechen",
    delete: "Löschen",
    open: "Öffnen",
    edit: "Bearbeiten",
    rename: "Umbenennen",
    create: "Anlegen",
    yes: "Ja",
    no: "Nein",
    or: "oder",
    email: "E-Mail",
    password: "Passwort",
    language: "Sprache",
    back: "Zurück",
    next: "Weiter",
    close: "Schließen",
    refresh: "Aktualisieren",
    paginationPrev: "Zurück",
    paginationNext: "Weiter",
    paginationPageOf: "Seite {{page}} von {{pages}}",
    paginationShowing: "{{from}}–{{to}} von {{total}}",
    paginationPerPage: "Pro Seite",
  },
  dateField: {
    open: "Datum wählen",
    placeholder: "Datum wählen",
    openCalendar: "Kalender öffnen",
    month: "Monat",
    year: "Jahr",
  },
  nav: {
    dashboard: "Dashboard",
    projects: "Projekte",
    companies: "Unternehmen",
    admin: "Admin",
  },
  auth: {
    metaTitle: "Anmelden — Grantonomy Timesheet AI",
    eyebrow: "Zugang erforderlich",
    title: "Anmelden",
    subtitle: "Zugriff auf deine FuE-Projekte.",
    passwordLabel: "Passwort",
    passwordSubmit: "Anmelden",
    passwordSubmitLoading: "Anmelden…",
    magicLink: "Magic Link per E-Mail",
    magicLinkLoading: "Wird gesendet…",
    magicLinkHelp: "Mit Passwort anmelden oder nur die E-Mail für einen Magic Link verwenden.",
    magicLinkSent: "Magic Link gesendet — bitte E-Mail-Postfach prüfen.",
    magicLinkNoEmail: "Bitte E-Mail eingeben",
    forgotPassword: "Passwort vergessen?",
    resetSent: "Wenn ein Zugang existiert, ist eine E-Mail unterwegs.",
    emailPlaceholder: "name@firma.de",
    turnstileLabel: "Bestätige, dass du kein Roboter bist.",
  },
  footer: {
    navAria: "Navigation",
    home: "Home",
    services: "Leistungen",
    contact: "Kontakt",
    about: "Über uns",
    projects: "Projekte",
    imprint: "Impressum",
    copyright: "© {{year}} Grantonomy. Alle Rechte vorbehalten.",
    product: "Grantonomy · Zeiterfassung",
  },
  setPassword: {
    metaTitle: "Passwort vergeben — Grantonomy",
    title: "Passwort vergeben.",
    subtitle: "Lege ein Passwort für deinen Zugang fest.",
    resetTitle: "Neues Passwort vergeben.",
    resetSubtitle: "Setze ein neues Passwort für deinen Zugang.",
    currentLabel: "Aktuelles Passwort",
    label: "Neues Passwort",
    confirmLabel: "Passwort wiederholen",
    hint: "Mindestens {{min_length}} Zeichen.",
    mismatch: "Die Passwörter stimmen nicht überein.",
    submit: "Passwort speichern",
    submitting: "Speichern…",
    success: "Passwort gespeichert.",
  },
  linkInvalid: {
    metaTitle: "Link ungültig — Grantonomy",
    title: "Link nicht mehr gültig.",
    expired: "Dieser Link ist abgelaufen. Fordere einfach einen neuen an.",
    used: "Dieser Link wurde zu oft verwendet und ist nicht mehr gültig. Fordere einfach einen neuen an.",
    invalid: "Dieser Link ist ungültig. Bitte fordere einen neuen an.",
    requestNew: "Neuen Link anfordern",
    employeeLogin: "Mitarbeiter-Login",
  },
  redeem: {
    metaTitle: "Anmelden — Grantonomy",
    title: "Fast geschafft.",
    intro:
      "Klicke auf „Anmelden“, um dich mit deinem persönlichen Link anzumelden. Der Link funktioniert genau einmal.",
    submit: "Anmelden",
    submitting: "Anmelden…",
  },
  dashboard: {
    metaTitle: "Dashboard — Grantonomy Timesheet AI",
    kicker: "Übersicht",
    title: "Deine FuE-Projekte.",
    newProject: "Neues Projekt",
    stats: {
      projects: "Projekte",
      employees: "Mitarbeiter",
      timesheets: "Erzeugte Stundenzettel",
    },
    recent: "Letzte Projekte",
    emptyTitle: "Noch keine Projekte",
    emptyBody: "Lege dein erstes FuE-Projekt an und erfasse die Stammdaten.",
    emptyCta: "Erstes Projekt anlegen",
    renamed: "Projekt umbenannt",
    renameFailed: "Umbenennen fehlgeschlagen",
    nameRequired: "Name erforderlich",
    viewCompanies: "Unternehmen",
    viewProjects: "Projekte",
    viewsLabel: "Dashboard-Ansicht",
    openAllCompanies: "Alle Unternehmen",
    openAllProjects: "Alle Projekte",
    showMorePage: "{{next}} weitere anzeigen ({{shown}} von {{total}})",
  },
  companies: {
    metaTitle: "Unternehmen — Grantonomy Timesheet AI",
    kicker: "Kunden",
    title: "Unternehmen",
    newCompany: "Neues Unternehmen",
    created: "Unternehmen angelegt",
    createFailed: "Anlegen fehlgeschlagen",
    emptyTitle: "Noch keine Unternehmen",
    emptyBody:
      "Lege ein Unternehmen über Neues Projekt an — im Firmenfeld „Neues Unternehmen anlegen…“ wählen.",
    formName: "Name",
    formState: "Bundesland",
    namePlaceholder: "Muster GmbH",
  },
  admin: {
    metaTitle: "Admin — Grantonomy Timesheet AI",
    kicker: "Admin",
    title: "Datenverwaltung",
    subtitle: "Nutzer, Einträge, E-Mail-Log, Wochennotizen und Festschreibungs-/Audit-Log.",
    empty: "Noch keine Projekte.",
    deleted: "Projekt gelöscht",
    deleteFailed: "Löschen fehlgeschlagen",
    confirmTitle: "Dieses Projekt löschen?",
    confirmBody:
      '"{{name}}" wird endgültig gelöscht — inklusive aller Mitarbeiter, Stundenzettel und Dokumente. Nicht rückgängig zu machen.',
    tabProjects: "Projekte",
    tabUsers: "Nutzer",
    tabEntries: "Einträge",
    tabEmail: "E-Mail-Log",
    tabWeekNotes: "Wochennotizen",
    tabLocks: "Festschreibung",
    tabAudit: "Änderungshistorie",
    tabSystemLogs: "Systemprotokolle",
    tabSettings: "Einstellungen",
    tabImports: "Importe",
    locksTitle: "Monatsfestschreibung",
    locksBody:
      "Firma und Projekt wählen, dann einen Zeitraum (Von–Bis) festschreiben oder mit Begründung öffnen.",
    locksCompany: "Unternehmen",
    locksProject: "Projekt",
    locksPickCompany: "Unternehmen wählen",
    locksPickProject: "Projekt wählen",
    locksPickCompanyHint: "Bitte zuerst ein Unternehmen wählen.",
    locksPickProjectHint: "Bitte ein Projekt wählen, um Sperren zu sehen.",
    matrixNoHours_one:
      "{{count}} Mitarbeiter ist diesem Projekt zugeordnet, hat für {{year}} aber noch keine Stunden erfasst.",
    matrixNoHours_other:
      "{{count}} Mitarbeiter sind diesem Projekt zugeordnet, haben für {{year}} aber noch keine Stunden erfasst.",
    matrixDownloadXlsx: "Live-Tracking XLSX",
    matrixDownloadDone: "Download gestartet.",
    weekNotesTitle: "Wochenbeschreibungen",
    weekNotesPickProject: "Bitte ein Projekt wählen.",
    weekNotesNoneForYear_one:
      "Für {{year}} wurden noch keine Wochenbeschreibungen gespeichert ({{count}} zugeordneter Mitarbeiter).",
    weekNotesNoneForYear_other:
      "Für {{year}} wurden noch keine Wochenbeschreibungen gespeichert ({{count}} zugeordnete Mitarbeiter).",
    weekNotesColWeek: "Woche",
    weekNotesColEmployee: "Mitarbeiter",
    weekNotesColDescription: "Beschreibung",
    weekNotesColAttachments: "Anhänge",
    weekNotesColUpdated: "Aktualisiert",
    emailEmpty: "Noch keine E-Mails protokolliert.",
    emailTemplate: "Vorlage",
    emailTemplateAll: "Alle Vorlagen",
    emailTemplateMagicLink: "Magic Link",
    emailTemplateInvite: "Einladung",
    emailTemplatePasswordReset: "Passwort zurücksetzen",
    emailTemplateReminder: "Erinnerung",
    emailTo: "Empfänger",
    emailRecipientPlaceholder: "Nach E-Mail suchen…",
    emailStatus: "Status",
    emailError: "Fehler",
    emailCreated: "Zeitpunkt",
    emailQueued: "{{count}} in Warteschlange",
    emailFailed: "{{count}} fehlgeschlagen",
    emailDailyGuardPaused: "Tageslimit erreicht — Normal-Mails pausiert ({{sent}}/{{cap}} in 24 h)",
    emailDailyGuardOk: "Tageskontingent {{sent}}/{{cap}} (24 h)",
    auditChainOk: "Hash-Kette verifiziert",
    auditChainFail: "Hash-Kette fehlerhaft",
    auditChainRows: "{{count}} Einträge",
    auditDownload: "Excel-Export",
    entriesAuditTitle: "Änderungshistorie",
    auditPickProject: "Projekt wählen",
    auditPickProjectHint: "Bitte ein Projekt wählen, um die Änderungshistorie zu sehen.",
    auditDay: "Tag",
    auditOldNew: "Alt → Neu",
    auditEmployee: "Mitarbeiter",
    auditWho: "Wer",
    auditOldNewHours: "h",
    auditOldNewAbsence: "Abwesenheit",
    auditOldNewRd: "F&E",
    auditOldNewWeekNote: "Wochenbeschreibung",
    auditEventsTitle: "Systemprotokolle",
    auditEventsBody: "Anwendungsereignisse (Logins, Einladungen, Exporte, Mandantenverwaltung).",
    auditWhen: "Zeitpunkt",
    auditAction: "Aktion",
    auditSource: "Quelle",
    auditBy: "Geändert von",
    auditChannel: "Kanal",
    auditReason: "Grund",
    auditHours: "h:",
    auditAbsence: "Abwesenheit:",
    auditRd: "FuE:",
    auditWeekDescription: "Wochenbeschreibung:",
    auditReasonLabel: "Grund:",
    auditEventType: "Ereignis",
    auditTarget: "Ziel",
    auditIp: "IP",
    auditFromTo: "Von → Nach",
    auditMethod: "Methode",
    auditMeta: "Meta",
    auditMetaDetails: "Details",
    auditMetaDialogTitle: "{{event}} · {{when}}",
    auditMetaDialogBody: "Vollständiges Meta-Objekt dieses Ereignisses.",
    auditEventsCsv: "CSV-Export",
    auditLoginMethod: {
      password: "Passwort",
      magic_link: "Magic-Link",
      invite: "Einladung",
      password_reset: "Passwort-Reset",
      login: "Magic-Link",
    },
    auditEvent: {
      login_succeeded: "Login",
      login_succeeded_with_method: "Login ({{method}})",
      login_failed: "Login fehlgeschlagen",
      logout: "Abmeldung",
      magic_link_issued: "Magic-Link gesendet",
      magic_link_denied: "Magic-Link abgelehnt",
      magic_link_redeemed: "Magic-Link eingelöst",
      invite_sent: "Einladung gesendet",
      invite_link_copied: "Einladungslink kopiert",
      password_reset_requested: "Passwort-Reset angefordert",
      password_set: "Passwort gesetzt",
      session_revoked: "Sitzung widerrufen",
      rate_limited: "Rate-Limit",
      company_created: "Unternehmen angelegt",
      company_updated: "Unternehmen geändert",
      company_archived: "Unternehmen archiviert",
      company_restored: "Unternehmen wiederhergestellt",
      company_deleted: "Unternehmen gelöscht",
      project_created: "Projekt angelegt",
      project_updated: "Projekt geändert",
      project_archived: "Projekt archiviert",
      project_restored: "Projekt wiederhergestellt",
      project_deleted: "Projekt gelöscht",
      employee_added: "Mitarbeiter hinzugefügt",
      employee_updated: "Mitarbeiter geändert",
      employee_archived: "Mitarbeiter archiviert",
      employee_restored: "Mitarbeiter wiederhergestellt",
      employee_role_changed: "Rolle geändert",
      employee_email_changed: "E-Mail geändert",
      assignment_created: "Zuordnung angelegt",
      assignment_updated: "Zuordnung geändert",
      assignment_removed: "Zuordnung entfernt",
      employees_imported: "Mitarbeiter importiert",
      month_locked: "Monat festgeschrieben",
      month_unlocked: "Monat entsperrt",
      export_stundenzettel: "Export Stundenzettel",
      export_year_matrix: "Export Jahresmatrix",
      export_admin_xlsx: "Export Änderungshistorie",
      export_admin_csv: "Export Systemprotokolle",
      export_attachments_zip: "Export Anhänge",
      reminder_settings_updated: "Erinnerungen geändert",
      reminder_sent: "Erinnerung gesendet",
      project_invites_sent: "Projekteinladungen gesendet",
      settings_updated: "Einstellung geändert",
      hours_imported: "Stunden importiert",
      audit_chain_verified: "Hash-Kette geprüft",
      dev_persona_switched: "Persona gewechselt",
    },
    systemLogsSearch: "Suchen",
    systemLogsSearchPlaceholder: "Ereignis, E-Mail, Ziel, IP…",
    systemLogsEventTypeAll: "Alle Ereignisse",
    systemLogsFrom: "Von",
    systemLogsTo: "Bis",
    systemLogsNoMatches: "Keine Treffer.",
    settingsSaved: "Einstellung gespeichert.",
    settingsInvalidValue: "Bitte Werte prüfen und erneut speichern.",
    settingsUpdated: "Zuletzt geändert",
    settingsEmailSectionTitle: "E-Mail",
    settingsEmailSectionBody:
      "App-weite Absender-Zugangsdaten und Outbox-Drosselung für Einladungen und Erinnerungen.",
    smtpMailTitle: "SMTP-Absender",
    smtpMailBody:
      "Absender-Adresse und App-Passwort. Host/Port bleiben in den Umgebungsvariablen (SMTP_HOST/PORT). Ohne gespeicherte Zugangsdaten gilt weiterhin SMTP_* aus der Umgebung. Das Passwort wird verschlüsselt gespeichert und nie im Klartext zurückgegeben.",
    smtpMailSender: "Absender-E-Mail",
    smtpMailSenderPlaceholder: "noreply@grantonomy.de",
    smtpMailReplyTo: "Antwortadresse (optional)",
    smtpMailReplyToPlaceholder: "support@firma.de",
    smtpMailPassword: "App-Passwort",
    smtpMailPasswordPlaceholder: "Google App-Passwort",
    smtpMailPasswordKeep: "Leer lassen, um das vorhandene Passwort zu behalten",
    smtpMailPasswordConfigured:
      "Ein Passwort ist hinterlegt. Neues Passwort nur zum Ändern eintragen.",
    smtpMailPasswordHint: "Einmal setzen; danach nur bei Rotation neu eingeben.",
    emailOutboxTitle: "Outbox-Drosselung",
    emailOutboxBody:
      "Begrenzt, wie schnell der Worker die E-Mail-Warteschlange abarbeitet. Standard: 30/Min., 1800/Tag, alle 2 s.",
    emailOutboxMaxPerMinute: "Max. Sendungen pro Minute",
    emailOutboxMaxPerMinuteHint: "Gesamtrate über alle Mail-Arten.",
    emailOutboxDailyCap: "Tageslimit normale Mails",
    emailOutboxDailyCapHint: "Rollenendes 24h-Pause für nicht-dringende Mails bei Erreichen.",
    emailOutboxWorkerInterval: "Worker-Intervall (ms)",
    emailOutboxWorkerIntervalHint: "Wie oft der Outbox-Worker aufwacht (Millisekunden).",
    workProfileLimitsTitle: "Arbeitsprofil-Grenzen",
    workProfileLimitsBody:
      "Maximale Stunden und Tage pro Woche beim Anlegen und Bearbeiten von Mitarbeitern. Wochenstunden dürfen Tage/Woche × Max. Stunden/Arbeitstag nicht überschreiten.",
    workProfileMaxHours: "Max. Stunden/Woche",
    workProfileMaxDays: "Max. Tage/Woche",
    workProfileMaxHoursPerDay: "Max. Stunden/Arbeitstag",
    workProfileMaxHoursPerDayHint:
      "Begrenzt Stunden/Woche auf Tage × diesen Wert (Standard 10). Die absolute Wochenobergrenze gilt weiterhin.",
    rdShareLimitsTitle: "FuE-Anteil-Grenzen",
    rdShareLimitsBody:
      "Erlaubter FuE-%-Bereich pro Zuordnung. Das Maximum begrenzt auch die Summe aktiver Anteile einer Person.",
    rdShareMinPercent: "Minimum %",
    rdShareMaxPercent: "Maximum %",
    rdShareLimitsHint: "Ganzzahlen von 1 bis 100; Minimum darf Maximum nicht überschreiten.",
    rateLimitsSectionTitle: "Ratenlimits",
    rateLimitsSectionBody:
      "Versuchskontingente für Login und Magic-Link pro IP (im Speicher, eine Instanz).",
    loginRateLimitTitle: "Login-Ratenlimit",
    magicLinkRateLimitTitle: "Magic-Link-Ratenlimit",
    rateLimitAttempts: "Versuche",
    rateLimitAttemptsHint: "Erlaubte Versuche im Zeitfenster vor der Sperre.",
    rateLimitWindow: "Fenster (Sekunden)",
    rateLimitWindowHint: "Länge des rollierenden Fensters in Sekunden (z. B. 900 = 15 Min.).",
    rateLimitLockout: "Sperre (Sekunden)",
    rateLimitLockoutHint: "Wartezeit nach ausgeschöpftem Kontingent (0 = keine).",
    authTokenTtlTitle: "Auth-Token-Laufzeiten",
    authTokenTtlBody:
      "Gültigkeitsdauer einmaliger Tokens in Sekunden. Standard: Login 3 Tage, Einladung 7 Tage, Passwort-Reset 30 Min.",
    authTokenTtlLogin: "Login-/Magic-Link-Token (Sekunden)",
    authTokenTtlLoginHint: "259200 = 72 Stunden.",
    authTokenTtlInvite: "Einladungs-Token (Sekunden)",
    authTokenTtlInviteHint: "604800 = 7 Tage.",
    authTokenTtlPasswordReset: "Passwort-Reset-Token (Sekunden)",
    authTokenTtlPasswordResetHint: "1800 = 30 Minuten.",
    settingsLegalSectionTitle: "Rechtliches",
    settingsLegalSectionBody:
      "Datenschutz und Nutzungsbedingungen erscheinen auf /privacy und /terms sowie in Einladungsmails. Markdown wird als formatierter Text gespeichert.",
    legalPrivacyTitle: "Datenschutz",
    legalPrivacyBody: "Öffentliche Datenschutzerklärung (Deutsch und Englisch).",
    legalTermsTitle: "Nutzungsbedingungen",
    legalTermsBody: "Öffentliche Nutzungsbedingungen (Deutsch und Englisch).",
    legalEditorFormatted: "Formatiert",
    legalEditorRaw: "Rohtext",
    legalEditorRawHint:
      "Rohtext wird so gespeichert, wie er eingegeben wird. Die formatierte Ansicht kann Syntax umschreiben, die der Editor nicht unterstützt.",
    importsEmpty: "Noch keine Importe.",
    importsKind: "Art",
    importsCompany: "Unternehmen",
    importsProject: "Projekt",
    importsFilename: "Datei",
    importsDryRun: "Dry-Run",
    importsStats: "Statistik",
    importsCreated: "Zeitpunkt",
    hoursImportTitle: "Historische Stunden importieren",
    hoursImportBody:
      "Dry-Run mit Abgleich pro Person/Monat. Vorlage entspricht dem Live-/Kalender-Export (E-Mail, Projekt, Datum, Stunden, FuE).",
    hoursImportCompany: "Unternehmen",
    hoursImportProject: "Projekt (optional)",
    hoursImportPickCompany: "Unternehmen wählen",
    hoursImportAllProjects: "Alle Projekte (Spalte „Projekt“)",
    hoursImportTemplate: "Vorlage laden",
    hoursImportUpload: "Datei prüfen",
    hoursImportPreviewDone: "Vorschau erstellt.",
    hoursImportTotals:
      "{{accepted}} Zeilen ok, {{rejected}} abgelehnt · Σ {{total}} h / {{rd}} h FuE",
    hoursImportRow: "Zeile",
    hoursImportReason: "Grund",
    hoursImportEmail: "E-Mail",
    hoursImportCommit: "Import ausführen",
    hoursImportCommitted:
      "Import fertig: {{inserted}} neu, {{updated}} geändert, {{unchanged}} unverändert.",
  },
  wizard: {
    step1Title: "Projekt",
    step1Desc: "Info & Dokumente",
    step2Title: "Mitarbeiter",
    step2Desc: "Daten & Zuordnung",
    step3Title: "Generieren",
    step3Desc: "Stundenzettel",
    step4Title: "Validieren",
    step4Desc: "Compliance-Checks",
    step5Title: "Export",
    step5Desc: "Download",
  },
  dropzone: {
    reading: "Lese Dateien…",
    dragActive: "Hier ablegen",
    idle: "Dateien ablegen oder klicken zum Hochladen",
    removeAria: "Entfernen",
  },
  festschreibung: {
    metaTitle: "Festschreibung — Grantonomy",
    title: "Monatsfestschreibung",
    body: "Projekt wählen, dann einen Zeitraum (Von–Bis) festschreiben. Öffnen ist nur Grantonomy Admin möglich.",
    project: "Projekt",
    pickProject: "Projekt wählen",
    pickProjectHint: "Bitte ein Projekt wählen, um Sperren zu sehen.",
  },
  legal: {
    metaTitle: "Datenschutz — Grantonomy",
    privacyMetaTitle: "Datenschutz — Grantonomy",
    termsMetaTitle: "Nutzungsbedingungen — Grantonomy",
    kicker: "Rechtliches",
    title: "Datenschutz",
    subtitle: "Informationen zur Verarbeitung Ihrer Daten.",
    linkPrivacy: "Datenschutz",
    linkTerms: "Nutzungsbedingungen",
    continueNotice:
      "Mit dem Fortfahren akzeptieren Sie die <0>Nutzungsbedingungen</0> und nehmen die <1>Datenschutzerklärung</1> zur Kenntnis.",
    localeDe: "Deutsch",
    localeEn: "English",
    emptyPrivacy: "Noch keine Datenschutzerklärung hinterlegt.",
    emptyTerms: "Noch keine Nutzungsbedingungen hinterlegt.",
  },
  notFound: {
    metaTitle: "Seite nicht gefunden — Grantonomy",
    title: "Seite nicht gefunden",
    body: "Diese Seite existiert nicht oder wurde verschoben.",
    home: "Zur Startseite",
  },
  errorBoundary: {
    title: "Diese Seite konnte nicht geladen werden",
    body: "Etwas ist schiefgelaufen. Bitte neu laden oder zur Startseite.",
    retry: "Erneut versuchen",
    home: "Zur Startseite",
  },
  appShell: {
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    mobileNavTitle: "Navigation",
    nav: {
      employees: "Mitarbeiter",
      myTracking: "Meine Zeiterfassung",
      festschreibung: "Festschreibung",
    },
    // Keyed by `users.role` so the sidebar can render the badge straight from the session.
    role: {
      grantonomyAdmin: "Grantonomy Admin",
      customerAdmin: "Unternehmens-Admin",
      grantonomy_admin: "Grantonomy Admin",
      company_admin: "Unternehmens-Admin",
      employee: "Mitarbeiter",
      signedIn: "Angemeldet",
    },
  },
  roleSwitcher: {
    label: "Test: Rolle",
    hint: "Nur Testphase — wechselt zu einem echten Seed-Benutzer der gewählten Rolle",
    roles: {
      grantonomy_admin: "GrantonomyAdmin",
      company_admin: "CompanyAdmin",
      employee: "Employee",
    },
  },
  audit: {
    nav: "Prüfungs-Assistent",
    kicker: "Prüfungs-Assistent",
    title: "Plausibilitätsprüfung wie das Finanzamt",
    subtitle:
      "KI-gestützte Prüfung der Stundenzettel für {{project}} — FuE-Anteil pro Rolle, Muster, Ausreißer und typische BSFZ-Rückfragen.",
    runCheck: "Prüfung starten",
    rerun: "Erneut prüfen",
    running: "Prüfe…",
    runningLong:
      "KI analysiert Stundenzettel, Rollen und FuE-Anteile — kann bis zu einer Minute dauern.",
    backToProject: "Zurück zum Projekt",
    emptyTitle: "Noch keine Prüfung durchgeführt",
    emptyBody:
      "Starte eine KI-gestützte Plausibilitätsprüfung. Wir bewerten FuE-Anteile pro Rolle, unrealistische Muster und typische Themen einer Betriebsprüfung.",
    findings: "Auffälligkeiten",
    noFindings: "Keine Auffälligkeiten gefunden. Sieht sauber aus.",
    overall: {
      ok: "Alles plausibel",
      warning: "Leichte Auffälligkeiten",
      critical: "Kritische Auffälligkeiten",
    },
  },
  assessment: {
    kicker: "Audit Assessment",
    title: "Prüfungsgespräch mit dem Finanzamt",
    subtitle:
      "Kritisches All-in Audit Assessment für {{project}} — Rollen, FuE-Zeiten, BSFZ-Bescheid und Projektinhalt im Kreuzverhör.",
    backToProject: "Zurück zum Projekt",
    opening: "Das Finanzamt sichtet die Unterlagen…",
    thinking: "Finanzamt schreibt…",
    placeholder: "Ihre Erklärung an das Finanzamt…",
    hint: "Cmd/Ctrl + Enter zum Senden",
    exportMarkdown: "Markdown",
    exportPdf: "PDF",
    restart: "Neu prüfen",
    roleUser: "Sie",
    roleAuditor: "Finanzamt",
    roleAuditorFull: "Finanzamt (Betriebsprüfung)",
    popupBlocked: "Popup blockiert",
    printSaveAsPdf: "Als PDF speichern",
    pdfKicker: "Audit Assessment — Forschungszulage",
    pdfCreated: "Erstellt am {{date}}",
    pdfFooter: "Generiert durch Grantonomy · {{date}}",
    failed: "Assessment fehlgeschlagen",
  },
  brand: {
    tagline: "Zeiterfassung",
  },
  employeeLogin: {
    title: "Mitarbeiter-Login",
    intro:
      "Gib deine E-Mail ein — wir schicken dir einen Login-Link. Der Zugang ist an deinen Account gebunden und geht nie verloren.",
    sentTitle: "Link versendet",
    sentBody:
      "Wir haben dir eine E-Mail an <b>{{email}}</b> geschickt. Öffne den Link darin, um dich anzumelden.",
    useOtherEmail: "Andere E-Mail verwenden",
    emailLabel: "E-Mail-Adresse",
    submit: "Login-Link senden",
    submitting: "Wird gesendet …",
    footnote:
      "Nur E-Mail-Adressen, die als Mitarbeiter in einem Projekt hinterlegt sind, können sich anmelden.",
    genericError: "Fehler",
    metaTitle: "Mitarbeiter-Login — Grantonomy",
  },
  forgotPassword: {
    metaTitle: "Passwort vergessen — Grantonomy",
    title: "Passwort vergessen.",
    subtitle: "Wir schicken dir einen Link, mit dem du ein neues Passwort festlegen kannst.",
    emailLabel: "E-Mail-Adresse",
    submit: "Link zum Zurücksetzen senden",
    submitting: "Wird gesendet …",
    sentTitle: "E-Mail prüfen",
    sentBody:
      "Prüfe dein Postfach. Wenn ein Zugang für <b>{{email}}</b> existiert, ist eine E-Mail unterwegs.",
    useOtherEmail: "Andere E-Mail",
    backToLogin: "Zurück zur Anmeldung",
    genericError: "Fehler",
  },
  track: {
    metaTitle: "Login erforderlich — Grantonomy",
    title: "Bitte anmelden",
    body: "Persönliche Tracking-Links wurden abgelöst. Melde dich jetzt mit deiner E-Mail-Adresse an — dein Zugang ist an deinen Account gebunden und geht nie mehr verloren.",
    cta: "Zum Mitarbeiter-Login",
  },
  myTracking: {
    metaIndex: "Meine Zeiterfassung — Grantonomy",
    metaProject: "Zeiterfassung — Grantonomy",
    heading: "Meine Projekte",
    intro: "Wähle ein Projekt, um Zeiten einzutragen.",
    loading: "Lade …",
    emptyProject:
      "Du bist aktuell keinem Projekt zugeordnet. Bitte wende dich an deinen Administrator.",
    year: "Jahr {{year}}",
    projectsBack: "Projekte",
    noAccess: "Kein Zugriff auf dieses Projekt.",
    back: "Zurück",
  },
  tracker: {
    hoursHeading: "Stundenerfassung {{year}}",
    hello: "Hallo {{name}}",
    projectPrefix: "Projekt: {{name}}",
    projectDash: "—",
    targetPerWeek: "Soll: {{weekly}}h/Woche ({{perDay}}h/Tag)",
    rdShare: "FuE-Anteil: {{pct}}%",
    holidaysIn: "Feiertage: {{state}}",
    excelExport: "Excel-Export",
    statTotal: "Gesamt",
    statRd: "davon FuE",
    statVac: "Urlaub",
    statSick: "Krank",
    statUnitHours: "Std.",
    statUnitDays: "Tage",
    missing: "fehlt",
    weeksShort: "Wo.",
    outsideWindowHint:
      "Außerhalb des Erfassungszeitraums (vor Projektstart, vor Eintrittsdatum oder nach Projektende).",
    outsideWindowBadge: "nicht verfügbar",
    monthHint:
      "Werte sind vorausgefüllt. Klick auf 🌴/🤒 wechselt zwischen ganzem Tag, halbem Tag und aus.",
    absentElsewhere: "An diesem Tag warst du in einem anderen Projekt abwesend.",
    noWorkdays: "Keine Arbeitstage in diesem Monat.",
    week: "Kalenderwoche {{kw}}",
    weekSaved: "Woche gespeichert",
    weekPartial: "teilweise gespeichert",
    colDay: "Tag",
    colWorkday: "Arbeitstag",
    workdayLockedHasData: "Für diesen Tag sind bereits Stunden erfasst.",
    workdayLockedAssigned: "Fester Arbeitstag — kann nicht abgewählt werden.",
    workdayExtraNeedsHours: "Für angehakte Extra-Tage bitte Stunden eintragen (FuE darf 0 sein).",
    workdayLockedHoliday: "Feiertag — Arbeitstag kann nicht geändert werden.",
    workdayLockedFuture: "Zukünftiger Tag — Arbeitstag kann nicht geändert werden.",
    workdayLockedOutside:
      "Außerhalb des Erfassungszeitraums — Arbeitstag kann nicht geändert werden.",
    workdayLockedMonth: "Monat gesperrt — Arbeitstag kann nicht geändert werden.",
    workdayLockedElsewhere:
      "Abwesenheit in einem anderen Projekt — Arbeitstag kann nicht geändert werden.",
    workdayLockedOtherProject:
      "Stunden in einem anderen Projekt — Arbeitstag kann nicht geändert werden.",
    colHours: "Stunden",
    /** Kurzer Hinweis unter Stunden bei mehreren aktiven Projekten. */
    hoursSharedFyi: "Tagesgesamt geteilt",
    hoursSharedTooltip:
      "Stunden (Gesamt) gelten für alle deine Projekte an diesem Tag. Eine Änderung hier aktualisiert die Stunden auch in den anderen Projekten.",
    hoursSharedTooltipWithProjects:
      "Stunden (Gesamt) gelten für alle deine Projekte an diesem Tag. Bereits erfasst in: <projects></projects>. Eine Änderung hier aktualisiert die Stunden auch in den anderen Projekten.",
    hoursSharedHintAria: "Hinweis: Stunden bereits in anderen Projekten erfasst",
    colRd: "davon FuE",
    colRdPlanned: "FuE (Antrag)",
    colRdActual: "FuE (tatsächlich)",
    colAbsence: "Abwesenheit",
    future: "zukünftig",
    vacation: "Urlaub",
    sick: "Krank",
    other: "Sonstiges",
    halfVacation: "½ Urlaub",
    halfSick: "½ Krank",
    halfOther: "½ Sonstiges",
    absenceClearsOtherProjectsTitle: "Stunden in anderen Projekten entfernen?",
    absenceClearsOtherProjectsBody:
      "An diesem Tag sind bereits Stunden erfasst ({{projects}}). Ganztägige Abwesenheit setzt die Stunden auf allen genannten Projekten auf 0 und entfernt die Einträge.",
    absenceClearsOtherProjectsConfirm: "Abwesenheit setzen",
    descLabel: "An was hast du diese Woche gearbeitet?",
    descPlaceholder: "Kurze Beschreibung der Tätigkeiten…",
    removeAria: "Entfernen",
    uploading: "Lädt…",
    attachFile: "Datei anhängen",
    attachmentsCount: "{{count}} / {{max}}",
    attachmentsEmpty: "Noch keine Dateien angehängt.",
    attachmentDownload: "Herunterladen",
    attachmentDelete: "Löschen",
    attachmentDeleteConfirm: "Datei wirklich löschen?",
    attachmentCapReached: "Maximal {{max}} Dateien pro Woche.",
    attachmentsZipExport: "Anhänge (ZIP)",
    attachmentsZipDone: "ZIP-Download gestartet.",
    attachmentsZipFailed: "ZIP-Export fehlgeschlagen.",
    attachmentsZipEmpty: "Keine Anhänge für {{year}}.",
    fileDeleteConfirm: "Datei wirklich löschen?",
    fileUploaded: "Datei hochgeladen",
    filesUploaded: "{{count}} Dateien hochgeladen",
    uploadFailed: "Upload fehlgeschlagen",
    genericError: "Fehler",
    saveAgain: "Woche erneut speichern",
    saveWeek: "Woche speichern",
    weekNothingEntered:
      "Bitte füllen Sie alle aktiven Tage (Zeilen) aus, indem Sie Ihre tatsächlichen FuE-Stunden angeben oder einen Abwesenheitsgrund wählen",
    weekAllZero: "Eine Woche mit durchgehend null Stunden kann nicht gespeichert werden.",
    weekZeroHoursRequireAbsence: "An Tagen mit 0 Stunden bitte eine Abwesenheit wählen.",
    weekActualRequired: "Bitte FuE (tatsächlich) für alle Tage ausfüllen (auch 0).",
    hoursInvalidNumber: "Bitte eine gültige Zahl eingeben.",
    hoursOverCap: "Maximal {{cap}} Stunden pro Tag.",
    rdOverTotal: "FuE darf die Gesamtstunden nicht überschreiten.",
    weekHoursInvalid: "Bitte ungültige Stunden korrigieren ({{dates}}).",
    futureWeekNotSaveable: "Zukünftige Wochen können noch nicht gespeichert werden.",
    reasonTitle: "Grund der Änderung",
    reasonBody:
      "Diese Woche wurde bereits gespeichert. Bitte gib einen Grund für die Änderung an — er wird im Audit-Log revisionssicher hinterlegt.",
    reasonPlaceholder:
      "z. B. Korrektur der FuE-Stunden am Mittwoch nach Rücksprache mit dem Projektleiter",
    reasonTooShort: "Bitte einen Grund angeben (min. 3 Zeichen)",
    weekSavedToast: "KW {{kw}} gespeichert",
    weekNotesSheet: "Wochennotizen",
    xlsxCol: {
      date: "Datum",
      weekday: "Wochentag",
      kw: "KW",
      hours: "Stunden",
      rd: "FuE-Stunden",
      absence: "Abwesenheit",
      fraction: "Anteil",
      holiday: "Feiertag",
      note: "Notiz",
      workedOn: "An was gearbeitet",
      docsCount: "Anzahl Dokumente",
      docs: "Dokumente",
      adminName: "Admin (Name)",
      adminEmail: "Admin (E-Mail)",
      adminEditedAt: "Admin-Bearbeitung am",
    },
  },
  projectOverview: {
    metaTitle: "Projekt — Grantonomy",
    kicker: "Projekt",
    loading: "Lädt…",
    backToDashboard: "Zurück zum Dashboard",
    audit: "Audit",
    editProject: "Projekt bearbeiten",
    moduleLabel: "Modul {{n}}",
    reconstructTitle: "Rekonstruktion",
    reconstructDesc:
      "Mitarbeiter per Excel importieren. Danach Stundenzettel generieren, validieren und exportieren.",
    reconstructCta: "Fortsetzen →",
    liveTitle: "Live-Tracking",
    liveDesc:
      "Excel mit Mitarbeiterdaten (Name, E-Mail) hochladen — Mitarbeiter werden automatisch angelegt und live getrackt.",
    liveCta: "Zum Live-Tracking →",
    skippedYears: "Übersprungene Jahre: {{years}}",
    noYearForModule: "Kein Jahr für dieses Modul konfiguriert.",
  },
  projectsNew: {
    metaTitle: "Neues Projekt — Grantonomy",
    uploadTitle: "BSFZ-Bescheid hochladen",
    uploadSubtitle:
      "Lade den BSFZ-Bescheid hoch — die KI extrahiert alles. Danach wählst du pro Jahr zwischen Rekonstruktion und Live-Tracking.",
    editSubtitle: "Projekt-Stammdaten bearbeiten und speichern.",
    forbidden: "Neue Projekte können nur Grantonomy-Admins anlegen.",
  },
  dashboardEmployee: {
    kicker: "Dashboard",
    heading: "Meine Projekte",
    intro: "Wähle ein Projekt, um deinen Stundenzettel zu öffnen.",
    emptyBody:
      "Du bist aktuell keinem Projekt zugeordnet. Bitte wende dich an deinen Administrator.",
  },
  companiesExtra: {
    showArchived: "Archivierte anzeigen",
    archivedBadge: "archiviert",
    utilizationOverview: "Auslastung & Übersicht",
    archived: "Firma archiviert",
    restored: "Firma wiederhergestellt",
    hardDeleted: "Firma endgültig gelöscht",
    archiveTitle: "Firma archivieren?",
    archiveBody:
      '„{{name}}" und alle zugehörigen Projekte werden ausgeblendet. Daten und Audit-Historie bleiben erhalten (GoBD). Kann jederzeit wiederhergestellt werden.',
    archiveConfirm: "Archivieren",
    restoreTitle: "Wiederherstellen",
    hardDeleteTitle: "Endgültig löschen?",
    hardDeleteBody:
      '„{{name}}" wird zusammen mit <strong>allen Projekten, Zeit-Einträgen, Wochennotizen, Anhängen, Sperren und der Audit-Historie</strong> unwiderruflich entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    hardDeleteConfirm: "Endgültig löschen",
    hardDeleteBodyPlain:
      '„{{name}}" wird zusammen mit allen Projekten, Zuordnungen und der Audit-Historie unwiderruflich entfernt. Das geht nur, solange nichts erfasst wurde.',
  },
  adminExtra: {
    metaTitle: "Admin — Alle Projekte",
    showArchived: "Archivierte anzeigen",
    archivedBadge: "archiviert",
    archived: "Archiviert",
    restored: "Wiederhergestellt",
    hardDeleted: "Endgültig gelöscht",
    restoreTitle: "Wiederherstellen",
    archiveTitle: "Archivieren",
    hardDeleteTitle: "Endgültig löschen",
    archiveDialogTitle: "Projekt archivieren?",
    archiveDialogBody:
      '„{{name}}" wird ausgeblendet. Zeit-Einträge und Audit-Historie bleiben erhalten (GoBD). Kann jederzeit wiederhergestellt werden.',
    archiveDialogConfirm: "Archivieren",
    hardDeleteDialogTitle: "Endgültig löschen?",
    hardDeleteDialogBody:
      '„{{name}}" wird zusammen mit <strong>allen Zeit-Einträgen, Wochennotizen, Anhängen, Sperren und der Audit-Historie</strong> unwiderruflich entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    hardDeleteDialogConfirm: "Endgültig löschen",
    genericError: "Fehler",
    colCompany: "Unternehmen",
    colRole: "Rolle",
    colEnabled: "Aktiv",
    colLastLogin: "Letzter Login",
    colLastEntry: "Letzter Eintrag",
    colCreatedAt: "Erstellt am",
    usersEmpty: "Keine Nutzer gefunden.",
    disable: "Deaktivieren",
    enable: "Aktivieren",
    enabled: "Ja",
    disabled: "Nein",
    userEnabled: "Nutzer aktiviert.",
    userDisabled: "Nutzer deaktiviert.",
    magicLink: "Magic Link",
    passwordReset: "Passwort-Reset",
    magicLinkSent: "Magic Link versendet.",
    passwordResetSent: "Passwort-Reset versendet.",
    selectProject: "Projekt wählen",
    year: "Jahr",
    projectTerm: "Projektlaufzeit: {{from}} – {{to}}",
    projectTermOpen: "Projektlaufzeit: ab {{from}} (kein Enddatum)",
    termRange: "vom {{from}} bis {{to}}",
    termOpen: "seit {{from}} ohne Enddatum",
    yearAdjusted:
      "„{{project}}“ läuft {{term}} — {{requested}} liegt außerhalb der Laufzeit, angezeigt wird {{shown}}.",
    noAssignees:
      "Diesem Projekt sind noch keine Mitarbeiter zugeordnet — ohne Zuweisung kann niemand Zeiten erfassen.",
    statusFull: "Voll (≥85%)",
    statusPartial: "Teilweise",
    statusEmpty: "Leer",
    communicationTitle: "Kommunikation",
    communicationIntro:
      "Einladungen und Erinnerungen an Mitarbeiter für dieses Projekt. Das Absender-Postfach wird app-weit unter Admin → Einstellungen (SMTP) konfiguriert.",
    placeholderHelp: "Platzhalter:",
    placeholderHelpDetail:
      "Jede Einladungs-E-Mail enthält immer den Button „Zugang einrichten“ und am Ende des Texts einen Fallback-Link.",
    copyInvitationLink: "Link kopieren",
    inviteLinkCopied: "Einladungslink kopiert.",
    inviteLinkCopyFailed: "Link konnte nicht kopiert werden.",
    logKindReminder: "Erinnerung",
    logKindInvite: "Einladung",
    inviteTitle: "Einladung zur Zeiterfassung",
    inviteIntro: "Personalisierte erste E-Mail mit Magic Link — einzeln oder als Sammelversand.",
    inviteSubject: "Betreff",
    inviteBody: "Text",
    saveTemplate: "Vorlage speichern",
    templateSaved: "Vorlagen gespeichert.",
    inviteSendBulk: "An {{count}} senden",
    inviteConfirmTitle: "Einladung an {{count}} Mitarbeiter senden?",
    inviteConfirmBody: "Jede Person erhält den personalisierten Text und ihren eigenen Magic Link.",
    inviteSent: "{{count}} Einladung(en) versendet.",
    reminderSubject: "Betreff",
    reminderBody: "Text",
    recipientsPlain: "Empfänger",
    selectionEmpty: "Auswahl leer",
    autoReminderTitle: "Automatische Erinnerung",
    autoReminderIntro:
      "Jeden festgelegten Wochentag an alle Mitarbeiter, die für {{month}} noch unvollständige Wochen haben.",
    reminderWeekday: "Wochentag",
    reminderHour: "Uhrzeit",
    reminderActive: "Automatischen Versand aktivieren",
    reminderActiveHint: "Läuft jeden {{weekday}} um {{hour}}:00.",
    saveSettings: "Einstellungen speichern",
    recipientsTitle: "Empfänger ({{count}}) — {{missing}} fehlend",
    recipientsIntro:
      "Für {{month}}. Der automatische Versand geht nur an {{missing}} Person(en) ohne vollständige Wochen. Du kannst die Erinnerung jetzt manuell auslösen.",
    recipientsNone:
      "Niemand fehlt für {{month}} — alle haben die vergangenen Arbeitstage eingetragen.",
    selectAll: "Alle",
    selectMissing: "Nur fehlende",
    selectNone: "Keine",
    selectPerson: "{{name}} auswählen",
    nextRunDisabled: "Automatischer Versand ist deaktiviert.",
    nextRunToday: "Automatischer Versand läuft heute.",
    nextRunIn: "Nächster automatischer Versand in {{days}} Tag(en)",
    alreadySent: "Bereits versendet am {{when}}",
    notYetSent: "Für {{month}} noch nicht versendet",
    badgeMissing: "Fehlt",
    badgeEntered: "Eingetragen",
    noEmail: "keine E-Mail",
    lastSent: "Zuletzt {{when}}",
    sendIndividually: "Einzeln senden",
    selectedCount: "{{count}} ausgewählt",
    sendSelection: "Auswahl senden ({{count}})",
    sendMissing: "An alle Fehlenden senden ({{count}})",
    reminderSent: "{{count}} Erinnerung(en) versendet.",
    reminderLog: "Versandprotokoll",
    reminderLogEmpty: "Noch keine Einladungen oder Erinnerungen versendet.",
    reminderLogKind: "Art",
    weekday1: "Montag",
    weekday2: "Dienstag",
    weekday3: "Mittwoch",
    weekday4: "Donnerstag",
    weekday5: "Freitag",
    weekday6: "Samstag",
    weekday7: "Sonntag",
    settingsSaved: "Erinnerungseinstellungen gespeichert.",
  },
  companyDetail: {
    metaTitle: "Unternehmen — Grantonomy",
    kicker: "Unternehmen",
    deleteCompany: "Löschen",
    deleteConfirm:
      "Unternehmen und alle zugehörigen Projekte, Mitarbeiter und Stundenzettel löschen?",
    deleted: "Unternehmen gelöscht",
    deleteFailed: "Löschen fehlgeschlagen",
    tabEmployees: "Mitarbeiter",
    tabProjects: "Projekte",
    tabUtilization: "Auslastung",
    peopleCount_one: "{{count}} Person im Unternehmen",
    peopleCount_other: "{{count}} Personen im Unternehmen",
    empIntro: "Mitarbeiter dieses Unternehmens stehen allen Projekten zur Verfügung.",
    empIntroEmpty:
      "Personen sind erst nützlich, wenn ein erstes Projekt existiert. Lege zuerst ein Projekt an.",
    add: "Hinzufügen",
    firstName: "Vorname",
    lastName: "Nachname",
    role: "Rolle",
    weeklyHours: "Wochenstunden",
    empAdded: "Mitarbeiter hinzugefügt",
    empEmpty:
      "Noch keine Mitarbeiter. Füge Mitarbeiter hinzu oder importiere sie über die Projekt-Anlage.",
    projectsBadge_one: "{{count}} Projekt",
    projectsBadge_other: "{{count}} Projekte",
    perWeek: "h/Woche",
    vacationShort: "Urlaub",
    sickShort: "Krank",
    empDeleteMulti: "Mitarbeiter aus allen {{count}} Projekten löschen?",
    empDeleteOne: "Mitarbeiter löschen?",
    projIntro: "Alle FuE-Projekte dieses Unternehmens, gruppiert nach Wirtschaftsjahr.",
    newProject: "Neues Projekt",
    projEmpty: "Noch keine Projekte für dieses Unternehmen.",
    noYear: "Ohne Jahr",
    projectsWord_one: "Projekt",
    projectsWord_other: "Projekte",
    utilIntro:
      "Pro Jahr getrennt: pro Projekt den FuE-Ziel-Anteil (%) aus den Projektdaten und darunter den tatsächlich getrackten FuE-Anteil (Actual % = FuE-Stunden ÷ getrackte Gesamtstunden des Jahres). Rechts stehen Σ Target und Σ Actual über alle Projekte. Wird pro Jahr > 100 % Target gebucht, wird die Zeile als <mark>Überbucht</mark> markiert.",
    utilNoProjects: "Keine Projekte.",
    colEmployee: "Mitarbeiter",
    colTargetActual: "Target % · Actual %",
    colStatus: "Status",
    utilNoEmp: "Keine Mitarbeiter in diesem Jahr.",
    statusOver: "Überbucht > 100%",
    capTitle: "FuE-Kapazität & projektübergreifende Überbuchung",
    capIntro:
      "Gebuchte FuE-Stunden über alle Projekte gegen die vertragliche Kapazität. Tageskappe = Wochenstunden ÷ Arbeitstage. 4h + 4h FuE auf zwei Projekten = 100% OK, 6h + 6h = überbucht.",
    capEmpty:
      "Noch keine Mitarbeiter in diesem Unternehmen — ohne Personen gibt es keine Kapazität.",
    capNoHoursForYear:
      "Für {{year}} wurden noch keine FuE-Stunden erfasst. Die Kapazitäten unten sind daher überall 0%.",
    capNoProjects:
      "Dieses Unternehmen hat noch keine Projekte — es wird nur das laufende Jahr angeboten.",
    capNoConflicts: "Keine überbuchten Tage — alle innerhalb der Kapazität.",
    capConflicts_one: "{{count}} überbuchter Tag gefunden",
    capConflicts_other: "{{count}} überbuchte Tage gefunden",
    capOverbooked: "Überbucht",
    capOverDays_one: "{{count}} Tag > 100%",
    capOverDays_other: "{{count}} Tage > 100%",
    capConflictDays: "Überbuchte Tage",
    capOverLimitDays: "Tage über dem Tagesmaximum",
    capOverLimitIntro:
      "FuE-Stunden über dem administrativen Tagesmaximum — ein harter Verstoß, kein weiches Soll-Überziehen.",
    capBooked: "Gebucht",
    capRdBooked: "FuE gebucht",
    capPerProject: "FuE je Projekt",
    capTotalHours: "Gesamtstunden",
    capCapacity: "Kapazität",
    capRd: "FuE",
    capDay: "Tag",
    capPeriod: "Zeitraum",
    gran_week: "Woche",
    gran_month: "Monat",
    gran_year: "Jahr",
    statusFull: "Voll",
    statusOk: "OK",
  },
  // The company-level Employees page (PRD §4.3) — one row per Mensch, kein Jahresfilter.
  employees: {
    metaTitle: "Mitarbeiter — Grantonomy",
    kicker: "Team",
    title: "Mitarbeiter",
    intro:
      "Alle Personen dieses Unternehmens. Der Zeitraum auf einem Projekt ergibt sich aus Projekteintrittsdatum und optionalem Projektaustrittsdatum der Zuweisung — es gibt keinen Jahresfilter.",
    identifierHint:
      "Die E-Mail-Adresse ist der eindeutige Identifikator und kann nachträglich nur durch Grantonomy geändert werden.",
    backToProject: "Zurück zum Projekt",
    backToCompany: "Zurück zum Unternehmen",
    chooseCompany: "Unternehmen wählen",
    chooseCompanyBody: "Wähle zuerst ein Unternehmen, um dessen Mitarbeiter zu sehen.",
    search: "Suchen",
    searchPlaceholder: "Name oder E-Mail",
    showArchived: "Archivierte anzeigen",
    empty: "Noch keine Mitarbeiter. Füge eine Person hinzu oder importiere ein Excel.",
    noMatches: "Keine Treffer.",
    colName: "Name",
    colPosition: "Position",
    colEmail: "E-Mail",
    colHours: "Std./Woche",
    colHoursLine1: "Std.",
    colHoursLine2: "Woche",
    colDays: "Tage/Woche",
    colDaysLine1: "Tage",
    colDaysLine2: "Woche",
    colProjects: "Projekte",
    colActions: "Aktionen",
    roleEmployee: "Mitarbeiter",
    roleCompanyAdmin: "Unternehmens-Admin",
    archivedBadge: "archiviert",
    noAssignments: "Keine Zuweisung",
    add: "Mitarbeiter hinzufügen",
    addTitle: "Mitarbeiter hinzufügen",
    addBody: "Person anlegen und direkt einem Projekt zuweisen.",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    position: "Position",
    positionPlaceholder: "z. B. Forschungsingenieurin",
    jobDescription: "Tätigkeitsbeschreibung",
    jobDescriptionPlaceholder: "z. B. Planung und Durchführung von Forschungsprojekten …",
    jobDescriptionHint: "{{count}} Zeichen übrig",
    weeklyHours: "Stunden/Woche",
    workdaysPerWeek: "Tage/Woche",
    weeklyHoursCapHint:
      "Laut Admin-Einstellungen beträgt das Wochenmaximum {{max}} h. Stunden/Woche und Tage/Woche sind informative Angaben.",
    weeklyHoursOverWorkdayCap:
      "Stunden/Woche dürfen {{max}} nicht überschreiten ({{days}} Tag(e) × {{perDay}} h/Arbeitstag).",
    workWeekdays: "Arbeitstage",
    workWeekdaysHint: "Bitte {{count}} Tag/Tage auswählen (aktuell {{selected}}).",
    role: "Rolle",
    sendInvite: "Einladung sofort senden",
    added: "Mitarbeiter angelegt",
    edit: "Bearbeiten",
    editTitle: "Mitarbeiter bearbeiten",
    editBody: "Name, Stunden/Woche, Arbeitstage und E-Mail.",
    updated: "Mitarbeiter aktualisiert",
    emailChangeWarning:
      "Die E-Mail-Adresse wird geändert. Alle offenen Links und Sitzungen der alten Adresse werden ungültig.",
    archive: "Archivieren",
    archiveTitle: "Person archivieren?",
    archiveBody:
      '„{{name}}" wird ausgeblendet und kann sich nicht mehr anmelden. Erfasste Stunden bleiben erhalten (GoBD) und die Person kann jederzeit zurückgeholt werden.',
    archived: "Person archiviert",
    restore: "Wiederherstellen",
    restored: "Person wiederhergestellt",
    promote: "Zum Unternehmens-Admin machen",
    demote: "Zu Mitarbeiter machen",
    roleChanged: "Rolle geändert",
    invite: "Einladung senden",
    inviteAgain: "Einladung erneut senden",
    invited: "Einladung verschickt",
    inviteMany: "Einladung senden ({{count}})",
    inviteResult: "{{sent}} verschickt · {{skipped}} übersprungen",
    neverSignedIn: "Noch nie angemeldet",
    neverSignedInInvited: "Noch nie angemeldet • Eingeladen {{count}}",
    assign: "Projekt zuweisen",
    assignTitle: "Projekt zuweisen",
    assignBody: "Projekt, Projekteintrittsdatum und FuE-Anteil für {{name}}.",
    assignProject: "Projekt",
    assignEntryDate: "Projekteintrittsdatum",
    assignLeaveDate: "Projektaustrittsdatum",
    assignLeaveDateHint:
      "Letzter erfassbarer Tag in diesem Projekt; spätere Monate sind nicht bearbeitbar.",
    assignRdShareColumnHeader: "FuE-Anteil (%)",
    assignRdShare: "FuE-Anteil ({{min}}–{{max}} %)",
    assignRdRemaining: "Maximalwert: {{max}} %",
    assignRdRemainingHint: "Bezogen auf die übrigen Projektzuordnungen dieser Person",
    assigned: "Projekt zugewiesen",
    editAssignment: "Zuweisung bearbeiten",
    editAssignmentBody: "Projekteintrittsdatum und FuE-Anteil ändert ausschließlich Grantonomy.",
    assignmentUpdated: "Zuweisung aktualisiert",
    removeAssignment: "Zuweisung entfernen",
    removeAssignmentTitle: "Zuweisung entfernen?",
    removeAssignmentBody: '„{{name}}" wird von „{{project}}" entfernt.',
    assignmentRemoved: "Zuweisung entfernt",
    assignmentArchived: "Zuweisung archiviert — erfasste Stunden bleiben erhalten.",
    lockedTooltip: "Enthält erfasste Stunden — nur Grantonomy kann das ändern.",
    noProjectsYet: "Für dieses Unternehmen gibt es noch kein Projekt.",
    import: "Excel-Import",
    importTitle: "Mitarbeiter aus Excel",
    importBody:
      'Vorlage „Grantonomy Timesheet Input – Live Tracking": Name, E-Mail, Wochenstunden, Tage/Woche und FuE-Anteil. Der Import legt Personen an und weist sie „{{project}}" zu.',
    importProject: "Zielprojekt",
    importEntryDate: "Standard-Projekteintrittsdatum",
    importEntryDateHint: "Gilt für Zeilen ohne eigenes Projekteintrittsdatum.",
    importLeaveDateHint:
      "Das Projektaustrittsdatum aus Excel gilt nur für neu angelegte Personen. Bei bestehenden Personen setzt du es in der Zuweisung.",
    importTemplate: "Vorlage herunterladen",
    importDrop: "Excel (.xlsx) hier ablegen oder klicken",
    importParsing: "Datei wird gelesen…",
    importPreview: "{{count}} Zeilen erkannt",
    importCommit: "{{count}} Personen übernehmen",
    importSummary: "{{created}} neu · {{assigned}} zugewiesen · {{skipped}} übersprungen",
    importColRow: "Excel-Zeile",
    importExcelRow: "Excel-Zeile {{n}}",
    importAdminFallback:
      "Wir betrachten {{name}} als Unternehmens-Admin. Du kannst das später ändern.",
    importColVerdict: "Ergebnis",
    verdict_create: "Neu anlegen",
    verdict_assign: "Zuweisen",
    verdict_skip: "Übersprungen",
    importDiffers: "Abweichende Stammdaten: {{fields}} — bleiben unverändert.",
    reason_duplicate_in_file: "Doppelte Zeile in der Datei",
    reason_belongs_to_other_company:
      "Nutzer mit dieser E-Mail ist einem anderen Unternehmen zugeordnet",
    reason_already_assigned: "Bereits diesem Projekt zugewiesen",
    reason_person_archived: "Person ist archiviert",
    reason_assignment_has_entries: "Enthält erfasste Stunden — nur Grantonomy kann das ändern",
    reason_first_user_must_be_company_admin:
      "Das Unternehmen braucht zuerst einen Unternehmens-Admin",
    reason_missing_email: "Keine E-Mail-Adresse",
    reason_job_description_too_long: "Tätigkeitsbeschreibung zu lang (max. 2000 Zeichen)",
    reason_missing_weekly_hours: "Keine Wochenstunden",
    reason_weekly_hours_over_max: "Wochenstunden über dem erlaubten Maximum",
    reason_weekly_hours_exceed_workday_cap:
      "Wochenstunden überschreiten Tage × Max. Stunden/Arbeitstag",
    reason_missing_workdays: "Keine Arbeitstage pro Woche",
    reason_missing_rd_share: "Kein FuE-Anteil",
    reason_rd_share_out_of_range: "FuE-Anteil liegt außerhalb des erlaubten Bereichs",
    reason_rd_share_exceeds_max:
      "FuE-Anteile über alle Projekte würden das konfigurierte Maximum überschreiten",
    reason_invalid_entry_date: "Projekteintrittsdatum unlesbar",
    reason_entry_before_project_start: "Projekteintrittsdatum liegt vor dem Projektstart",
    reason_entry_after_project_end: "Projekteintrittsdatum liegt nach dem Projektende",
    reason_entry_too_far_in_future: "Projekteintrittsdatum liegt zu weit in der Zukunft",
    reason_invalid_leave_date: "Projektaustrittsdatum unlesbar",
    reason_assignment_leave_before_entry:
      "Projektaustrittsdatum liegt vor dem Projekteintrittsdatum",
    reason_assignment_leave_after_project_end: "Projektaustrittsdatum liegt nach dem Projektende",
    reason_assignment_leave_before_project_start:
      "Projektaustrittsdatum liegt vor dem Projektstart",
    reason_empty_workbook: "Die Datei enthält keine Tabelle",
  },
  projectsList: {
    metaTitle: "Projekte — Grantonomy",
    kicker: "Unternehmen",
    title: "Projekte",
    intro: "Ein Projekt läuft über seine gesamte Laufzeit — das Jahr ist nur eine Ansicht.",
    chooseCompanyIntro:
      "Wähle zuerst ein Unternehmen, um dessen Projekte zu sehen. Neue Unternehmen legst du über Neues Projekt an.",
    newProject: "Neues Projekt",
    showArchived: "Archivierte anzeigen",
    empty: "Noch keine Projekte.",
    yearFilter: "Jahr",
    allYears: "Alle Jahre",
    allCompanies: "Alle Unternehmen",
    selectCompany: "Projekte anzeigen",
    manageCompany: "Unternehmen verwalten",
    backToCompanies: "Alle Unternehmen",
    searchCompanies: "Unternehmen suchen",
    searchProjects: "Projekt suchen",
    runtime: "Laufzeit",
    open: "Ohne Ende",
    people_one: "{{count}} Person",
    people_other: "{{count}} Personen",
    archivedBadge: "archiviert",
    toEmployees: "Mitarbeiter des Unternehmens",
  },
  projectForm: {
    title: "Neues Projekt",
    subtitle: "Projekt-Stammdaten (Name, Laufzeit und Förderdetails).",
    companySection: "Unternehmen",
    companySectionHint: "Bestehendes Unternehmen wählen oder direkt ein neues anlegen.",
    company: "Unternehmen",
    newCompany: "Neues Unternehmen anlegen…",
    newCompanyHint:
      "Name und Bundesland des neuen Unternehmens — wird erst mit dem Projekt gespeichert.",
    createCompany: "Unternehmen anlegen",
    companyName: "Name des Unternehmens",
    infoSection: "Projektinformationen",
    infoSectionHint: "Prüfen und bearbeiten. Pflichtfelder müssen vor dem Anlegen gesetzt sein.",
    name: "Projekttitel",
    namePlaceholder: "Wird im Dashboard angezeigt",
    nameHint: "Angezeigt im Dashboard. Frei editierbar.",
    bsfzDescription: "BSFZ-Projektbeschreibung",
    bsfzDescriptionPlaceholder: "Kurzname laut BSFZ-Bescheid",
    bsfzDescriptionHint: "Wird als Projekttitel auf dem Stundenzettel verwendet.",
    projectCode: "Projekt-ID (Lfd. Nr.)",
    projectCodePlaceholder: "666-969-422/2026-1",
    projectCodeHint: "Laufende Nummer aus dem BSFZ-Bescheid. Optional.",
    projectCodeInvalid: "Format wie 666-969-422/2026-1 (drei Dreierblöcke / Jahr-Nr).",
    startDate: "Projektstart",
    endDate: "Projektende",
    submit: "Projekt anlegen",
    created: "Projekt angelegt",
    editTitle: "Projekt bearbeiten",
    saved: "Projekt gespeichert",
    archive: "Archivieren",
    archived: "Projekt archiviert",
    restore: "Wiederherstellen",
    restored: "Projekt wiederhergestellt",
    delete: "Löschen",
    deleteDisabledHint: "Das geht nur, solange keine Stunden erfasst sind.",
    deleteTitle: "Projekt endgültig löschen?",
    deleteBody:
      '„{{name}}" wird unwiderruflich entfernt. Das geht nur, solange keine Stunden erfasst sind.',
    deleteConfirm: "LÖSCHEN",
    deleteConfirmHint: "Tippe LÖSCHEN, um zu bestätigen.",
    deleted: "Projekt gelöscht",
    liveComingSoon: "Live-Tracking folgt in Phase 4.",
  },
  dashboardExtra: {
    backToDashboard: "Zurück zum Dashboard",
    projects_one: "Projekt",
    projects_other: "Projekte",
    years_one: "Jahr",
    years_other: "Jahre",
  },
  scaffold: {
    title: "In Arbeit",
    body: "Dieser Bereich wird in einer späteren Phase gebaut.",
  },
  liveStatus: {
    title: "Live-Erfassungsstatus",
    subtitle: "{{month}} · sortiert nach Erfassungslücken",
    loading: "Status wird geladen…",
    activeProjects: "Aktive Projekte",
    totalEmployees: "Mitarbeiter gesamt",
    monthEntered: "Monat vollständig erfasst",
    monthEnteredHint_one: "{{count}} offen",
    monthEnteredHint_other: "{{count}} offen",
    monthEnteredAll: "alles erledigt",
    avgCompletion: "Ø Erfassungsquote",
    month: "Monat",
    completion: "Fortschritt",
    captureRate: "Erfassungsquote",
    weeksMonth: "Wochen {{month}}",
    openLive: "Öffnen",
    expand: "Details",
    collapse: "Schließen",
    empty: "Noch keine Live-Projekte mit Mitarbeitern.",
    idleBadge: "Kein Tracking",
    idleHint: "keine Mitarbeiter im aktuellen Monat",
    idleEmpty: "Für diesen Monat sind keine Mitarbeiter zugewiesen — kein Tracking aktiv.",
    actualWeek: "Ist Woche:",
    actualMonth: "Ist Monat:",
    yearPct: "Jahr {{year}}",
    descriptionWeek: "Beschreibung Woche:",
    noEmployees: "Keine aktiven Mitarbeiter in dieser Woche.",
    yearTotal: "Σ Jahr",
    projectTotal: "Σ Projekt",
    tileTeamComplete: "Team vollständig",
    tileTeamCompleteHint: "Mitarbeiter mit allen Wochen erfasst",
    tileWeeksTracked: "Wochen erfasst",
    tileWeeksTrackedHint: "{{pct}} % im {{month}}",
    tileWithoutEntry: "Ohne Eintrag",
    tileWithoutEntryHint: "Mitarbeiter ohne erfasste Woche",
    tileAvgRd: "Ø F&E-Anteil",
    tileAvgRdHint: "gewichtet nach Stunden, Monat",
    tileLastCapture: "Letzte Erfassung",
    lastCaptureToday: "heute",
    lastCaptureYesterday: "vor 1 Tag",
    lastCaptureDays: "vor {{count}} Tagen",
    lastCaptureNone: "keine Erfassung",
    weekNoteYes: "Woche ✓",
    weekNoteNo: "Woche ·",
    lastEntry: "zuletzt {{date}}",
    lastEntryOn: "Zuletzt erfasst: {{date}}",
    noEntry: "kein Eintrag",
    weeks: "Wochen",
    weeksShort: "{{saved}}/{{total}} Wo.",
    weeksCell: "{{saved}}/{{total}} W",
    monthNa: "n/a",
    cellRdPct: "{{pct}} % F&E",
    monthTooltipHead: "{{name}} · {{month}}",
    monthTooltipNa: "{{name}} · {{month}}\nNicht im Projektzeitraum (n/a)",
    monthTooltipWeeks: "Wochen erfasst: {{saved}} von {{total}}{{kw}}",
    monthTooltipHours: "Stunden: {{hours}} h · davon FuE {{rd}} h ({{rdPct}} %)",
    monthTooltipNotes: "Beschreibungen: {{notes}} von {{saved}} Wochen",
    monthTooltipLast: "Letzte Erfassung: {{last}}",
    kwRange: "KW {{from}}–{{to}}",
    kwSingle: "KW {{week}}",
    kwNone: "KW —",
    legendGreen: "alle Wochen erfasst",
    legendYellow: "teilweise erfasst",
    legendRed: "keine Woche erfasst",
    legendGrey: "nicht im Projektzeitraum",
    legendWeeks: "W = Kalenderwochen",
    notesIncomplete: "Beschreibungen unvollständig",
    remind: "Reminder",
    remindHint: "Erinnerung senden",
    remindConfirm: "E-Mail an {{name}} ({{email}}) senden?",
    remindSend: "Senden",
    rdPct: "FuE %",
    weeklyRagLabel: "Wochen erfasst: {{saved}} von {{total}}",
  },
  monthLock: {
    title: "Monatsfestschreibung",
    body: "Festgeschriebene Zeiträume können nicht mehr bearbeitet werden — außer Grantonomy öffnet sie mit Begründung.",
    lock: "Zeitraum festschreiben",
    unlock: "Öffnen",
    unlockTitle: "Zeitraum öffnen",
    unlockBody:
      "Bitte einen Grund angeben (mind. 3 Zeichen). Der Vorgang wird im Audit-Log gespeichert.",
    reasonPlaceholder: "z. B. Korrektur nach Rücksprache mit dem Kunden",
    reasonTooShort: "Bitte einen Grund angeben (mind. 3 Zeichen)",
    lockedToast: "{{fromMonth}}–{{toMonth}}/{{year}} festgeschrieben",
    unlockedToast: "{{fromMonth}}–{{toMonth}}/{{year}} geöffnet",
    lockedBadge: "festgeschrieben",
    unlockedBadge: "geöffnet",
    lockedHint: "Dieser Monat ist festgeschrieben.",
    lockedMonthBody: "Dieser Monat ist festgeschrieben und kann nicht mehr bearbeitet werden",
    noLocks: "Keine festgeschriebenen Zeiträume.",
    selectMonth: "Monat",
    selectFromMonth: "Von",
    selectToMonth: "Bis",
    selectYear: "Jahr",
    outsideTerm:
      "Nur Monate innerhalb der Projektlaufzeit ({{term}}) können festgeschrieben werden.",
    entireProject: "(gesamtes Projekt)",
    lockedOn: "Festgeschrieben am {{when}}",
    unlockedOn: "geöffnet am {{when}} – Grund: {{reason}}",
    caCannotUnlock: "Nur Grantonomy kann festgeschriebene Monate öffnen.",
  },
  adminEdit: {
    title: "Stundenzettel bearbeiten – {{name}}",
    description: "Admin-Modus für {{year}}. Alle Änderungen werden im Audit-Log protokolliert.",
    open: "Bearbeiten",
  },
  projectLive: {
    metaTitle: "Live-Tracking — Grantonomy",
    kicker: "Live-Tracking",
    title: "Live-Übersicht",
    overviewTitle: "Jahresübersicht {{year}}",
    overviewSubtitle:
      "Gesamtstunden (h) und FuE-Stunden pro Monat. Klicke einen Monat an, um ihn hervorzuheben.",
    overviewHolidayHint: "Feiertage nach {{bundesland}}",
    timeframe: "Jahr {{start}} – {{end}}",
    timeframeSingle: "Jahr {{year}}",
    timeframeOpen: "Jahr {{start}} – Ohne Ende",
    manageEmployees: "Mitarbeiter verwalten",
    yearTotal: "Σ Jahr",
    yearTotalGroup: "Jahresgesamt",
    colHours: "h",
    colRd: "FuE",
    colPct: "%",
    currentMonthLegend: "Aktueller Monat",
    scrollHint: "Horizontal scrollen für das volle Jahr",
    rdActualTarget: "FuE ist / Ziel",
    action: "Aktion",
    outsideEmployment: "Außerhalb des Beschäftigungszeitraums",
    emptyEmployees: "Noch keine Mitarbeiter.",
    weekNotesTitle: "Wochenbeschreibungen",
    weekNotesSubtitle: "Was Mitarbeiter für jede Woche eingetragen haben ({{year}}).",
    weekNotesEmpty: "Noch keine Wochenbeschreibungen für {{year}}.",
    weekNotesError: "Wochenbeschreibungen konnten nicht geladen werden.",
    back: "Zurück zu Projekten",
    year: "Jahr",
    live: "Live",
    retrospective: "Retrospektiv",
    yearWithMode: "{{year}} · {{mode}}",
    stepsLabel: "Live-Modul Navigation",
    step2Title: "Mitarbeiter",
    step3Title: "Übersicht",
    step4Title: "Kommunikation",
    bulkTitle: "Excel-Vorlage (Sammelimport)",
    bulkBody:
      "„Grantonomy Timesheet Input – Live Tracking“ mit Name, E-Mail, Wochenstunden und FuE-Anteil.",
    rosterTitle: "Mitarbeiter ({{count}})",
    rosterEmptyHint: "Optional — oder Mitarbeiter einzeln anlegen.",
    rosterHeading: "Mitarbeiter im Projekt",
    employee: "Mitarbeiter",
    hours: "Stunden",
    rd: "FuE",
    weeks: "Wochen",
    empty: "Diesem Projekt sind noch keine Mitarbeiter zugeordnet.",
    loading: "Lädt…",
    exportYearMatrix: "Jahr-Matrix (XLSX)",
    exportAttachmentsZip: "Anhänge (ZIP)",
    exportStundenzettelZip: "Stundenzettel (ZIP)",
    exportStundenzettelZipDone: "Stundenzettel-ZIP heruntergeladen",
    exportStundenzettelZipFailed: "Stundenzettel-ZIP konnte nicht heruntergeladen werden",
    exportDone: "Export erstellt.",
    exportFailed: "Export fehlgeschlagen.",
    exportPerson: "Stundenzettel",
  },
  // Keyed by the error codes of src/shared/errors.ts. The database raises German text for the
  // server log; what the user reads is rendered from the code (PRD §6.4).
  errors: {
    DAY_FUTURE_HOURS: "Arbeitsstunden in der Zukunft sind nicht erlaubt.",
    DAY_BEFORE_ASSIGNMENT: "Das Datum liegt vor dem Projekteintritt ({{assignment_entry_date}}).",
    DAY_IS_HOLIDAY: "An einem Feiertag ({{holiday}}) können keine Stunden erfasst werden.",
    ABSENCE_FULL_REQUIRES_ZERO: "Eine ganztägige Abwesenheit erlaubt keine Arbeitsstunden.",
    ABSENCE_INCONSISTENT: "Abwesenheitsart und Anteil müssen zusammenpassen.",
    ABSENCE_BLOCKED_BY_OTHER_PROJECT_HOURS:
      "An ausgewählten Tag(en) sind bereits Stunden in einem anderen Projekt erfasst — Abwesenheit ist nicht möglich.",
    ZERO_HOURS_REQUIRE_ABSENCE: "An Tagen mit 0 Stunden bitte eine Abwesenheit wählen.",
    DAILY_CAP_EXCEEDED: "Die Stunden überschreiten das Tagesmaximum ({{daily_cap}} h).",
    WEEKLY_HOURS_EXCEEDED:
      "Die Wochenstunden ({{week_total}} h) überschreiten die vertraglichen Wochenstunden ({{weekly_hours}} h).",
    ENTRY_FUTURE_HOURS: "FuE-Stunden in der Zukunft sind nicht erlaubt.",
    ENTRY_BEFORE_ASSIGNMENT: "Das Datum liegt vor dem Projekteintritt ({{assignment_entry_date}}).",
    ENTRY_BEFORE_PROJECT_START: "Das Datum liegt vor dem Projektstart ({{project_start_date}}).",
    ENTRY_AFTER_PROJECT_END: "Das Datum liegt nach dem Projektende ({{project_end_date}}).",
    ENTRY_AFTER_LEAVE:
      "Das Datum liegt nach dem Projektaustrittsdatum ({{assignment_leave_date}}).",
    YEAR_BEFORE_PROJECT_START:
      "Das Jahr {{year}} liegt vor dem Projektstart ({{project_start_date}}).",
    YEAR_AFTER_PROJECT_END: "Das Jahr {{year}} liegt nach dem Projektende ({{project_end_date}}).",
    MONTH_BEFORE_PROJECT_START:
      "Der Monat {{month}}/{{year}} liegt vor dem Projektstart ({{project_start_date}}).",
    MONTH_AFTER_PROJECT_END:
      "Der Monat {{month}}/{{year}} liegt nach dem Projektende ({{project_end_date}}).",
    DAY_RECORD_MISSING: "Für diesen Tag sind noch keine Gesamtstunden erfasst.",
    RD_EXCEEDS_TOTAL:
      "FuE-Stunden dürfen die Gesamtstunden ({{total_hours}} h) nicht überschreiten.",
    CROSS_PROJECT_OVERBOOKING:
      "Am {{date_label}} überschreiten die FuE-Stunden über alle Projekte die Gesamtstunden ({{total_hours}} h).",
    CROSS_PROJECT_OVERBOOKING_hint: "Am {{date_label}} bereits erfasst:",
    /** Option-B-Toast-Titel (Querschnitt Überbuchung). */
    CROSS_PROJECT_OVERBOOKING_title:
      "Am {{date_label}} ist FuE (tatsächlich) in anderen Projekt(en) bereits erfasst:",
    CROSS_PROJECT_OVERBOOKING_line: "• {{name}} — {{hours}} Std.",
    CROSS_PROJECT_OVERBOOKING_more: "+{{count}} weitere",
    CROSS_PROJECT_OVERBOOKING_footer:
      "Gesamtstunden ({{total_hours}} h) — FuE (tatsächlich) senken oder Stunden erhöhen.",
    NO_ASSIGNMENT: "Die Person ist diesem Projekt nicht zugeordnet.",
    NO_WORK_PROFILE: "Für diese Person sind keine Wochenstunden hinterlegt.",
    RETRO_REASON_REQUIRED:
      "Rückwirkende Änderungen benötigen einen Änderungsgrund (mind. 3 Zeichen).",
    CHANGE_REASON_REQUIRED:
      "Änderungen an bereits gespeicherten Stunden benötigen einen Änderungsgrund (mind. 3 Zeichen).",
    MONTH_LOCKED:
      "Der Monat {{month}}/{{year}} ist festgeschrieben (Projekt „{{project_name}}“). Bitte zuerst mit Begründung öffnen.",
    AUDIT_APPEND_ONLY: "Das Audit-Protokoll ist revisionssicher und kann nicht geändert werden.",
    ASSIGNMENT_COMPANY_MISMATCH: "Person und Projekt gehören zu verschiedenen Unternehmen.",
    ASSIGNMENT_ENTRY_BEFORE_PROJECT_START:
      "Das Projekteintrittsdatum darf nicht vor dem Projektstart liegen ({{project_start_date}}).",
    ASSIGNMENT_ENTRY_AFTER_PROJECT_END:
      "Das Projekteintrittsdatum darf nicht nach dem Projektende liegen ({{project_end_date}}).",
    ASSIGNMENT_ENTRY_TOO_FAR_IN_FUTURE:
      "Das Projekteintrittsdatum darf höchstens bis zum {{horizon_date}} liegen (Ende des übernächsten Monats).",
    ASSIGNMENT_LEAVE_BEFORE_ENTRY:
      "Das Projektaustrittsdatum darf nicht vor dem Projekteintritt liegen ({{entry_date}}).",
    ASSIGNMENT_LEAVE_BEFORE_PROJECT_START:
      "Das Projektaustrittsdatum darf nicht vor dem Projektstart liegen ({{project_start_date}}).",
    ASSIGNMENT_LEAVE_AFTER_PROJECT_END:
      "Das Projektaustrittsdatum darf nicht nach dem Projektende liegen ({{project_end_date}}).",
    FIRST_USER_MUST_BE_COMPANY_ADMIN:
      "Die erste Person eines Unternehmens muss ein Unternehmens-Admin sein.",
    LAST_COMPANY_ADMIN_PROTECTED:
      "Das Unternehmen benötigt mindestens einen aktiven Unternehmens-Admin.",
    EMAIL_IMMUTABLE:
      "Die E-Mail-Adresse ist der eindeutige Identifikator und kann nachträglich nur durch Grantonomy geändert werden.",
    EMAIL_TAKEN: "Diese E-Mail-Adresse wird bereits verwendet.",
    RD_SHARE_EXCEEDS_MAX:
      "Die FuE-Anteile über alle Projekte dürfen {{max}} % nicht überschreiten (noch {{remaining}} % verfügbar).",
    RD_SHARE_OUT_OF_RANGE:
      "ungültiger FuE-% - bitte eine Zahl zwischen {{min}}% und {{max}}% eingeben",
    ASSIGNMENT_HAS_ENTRIES: "Enthält erfasste Stunden — nur Grantonomy kann das ändern.",
    ASSIGNMENT_HAS_ENTRIES_AFTER_LEAVE:
      "Es gibt bereits erfasste Stunden nach dem Projektaustrittsdatum (letzter Eintrag {{latest_entry_date}}).",
    HAS_TRACKED_DATA:
      "Es sind bereits Daten erfasst. Der Eintrag kann nur archiviert, nicht gelöscht werden.",
    UNAUTHENTICATED: "Bitte melde dich an.",
    INVALID_CREDENTIALS: "E-Mail-Adresse oder Passwort ist falsch.",
    ACCOUNT_DISABLED: "Dieser Zugang ist deaktiviert. Bitte wende dich an Grantonomy.",
    PASSWORD_SETUP_REQUIRED: "Bitte vergib zuerst ein Passwort.",
    WEAK_PASSWORD: "Das Passwort muss mindestens {{min_length}} Zeichen lang sein.",
    FORBIDDEN: "Dafür fehlt dir die Berechtigung.",
    TURNSTILE_FAILED: "Die Verifizierung ist fehlgeschlagen. Bitte versuche es erneut.",
    NOT_FOUND: "Nicht gefunden.",
    RATE_LIMITED: "Zu viele Versuche. Bitte versuche es in {{seconds}} Sekunden erneut.",
    RATE_LIMITED_LOGIN:
      "Zu viele Anmeldeversuche. Höchstens {{attempts}} Versuche in {{window}}. Nächster Versuch in {{countdown}}.",
    RATE_LIMITED_EMAIL:
      "Zu viele E-Mail-Anfragen. Höchstens {{attempts}} E-Mails in {{window}}. Nächste E-Mail in {{countdown}}.",
    TOKEN_INVALID: "Dieser Link ist ungültig.",
    TOKEN_EXPIRED: "Dieser Link ist abgelaufen.",
    TOKEN_USED: "Dieser Link wurde bereits verwendet.",
    INVALID_INPUT: "Die Eingabe ist unvollständig oder ungültig.",
    CONFLICT: "Der Datensatz wurde zwischenzeitlich geändert.",
    ALREADY_ASSIGNED: "Bereits diesem Projekt zugewiesen.",
    CONSTRAINT_VIOLATED: "Die Eingabe verletzt eine Datenregel.",
    REFERENCE_NOT_FOUND: "Der referenzierte Datensatz existiert nicht.",
    MISSING_ACTOR_CONTEXT: "Der Vorgang konnte nicht zugeordnet werden. Bitte versuche es erneut.",
    ATTACHMENT_TOO_LARGE: "Die Datei ist zu groß (max. 10 MB).",
    ATTACHMENT_TYPE_REJECTED: "Dieser Dateityp ist nicht erlaubt.",
    ATTACHMENT_CAP_EXCEEDED: "Maximal 4 Dateien pro Woche.",
    ATTACHMENT_QUOTA_EXCEEDED: "Speicherkontingent des Unternehmens ist erschöpft.",
    ATTACHMENT_ZIP_TOO_LARGE:
      "Der ZIP-Export überschreitet 300 MB — bitte Jahr oder Umfang reduzieren.",
    STUNDENZETTEL_MINDESTANGABEN_MISSING:
      "Der Stundenzettel kann nicht erstellt werden. Vorhaben-ID und FuE-Tätigkeit (Position) müssen hinterlegt sein.",
    INTERNAL_ERROR: "Es ist ein unerwarteter Fehler aufgetreten.",
  },
};

export type Translations = typeof de;
